import Konva from 'konva';

export default class WrappedArrow extends Konva.Group {
  constructor(config) {
    super(config);
    this._viewWidth = config.viewWidth;
    this._points = [{x:0, y:0}];
    this.arrow = new Konva.Arrow({
      stroke: "blue",
      strokeWidth: 4,
      pointerLength: 10,
      pointerWidth: 12,
      tension: 0.5,
      visible: true,
    });
    this.add(this.arrow);
    this.lines = [];
  }

  addLine() {
    const line = new Konva.Arrow({
      stroke: "blue",
      strokeWidth: 4,
      pointerLength: 10,
      pointerWidth: 12,
      tension: 0.5,
      visible: false,
    });
    this.add(line);
    this.lines.push(line);
  }

  viewWidth(width) {
    if (!width) {
      return this._viewWidth;
    }
    this._viewWidth = width;
    this.updateLines();
  }

  points(points) {
    if (!points) {
      return this._points;
    }
    this._points = points;
    this.updateLines();
  }

  normalizePoints(points) {
    while (points[points.length-1].x < 0) {
      points.forEach(point => point.x += this.viewWidth());
    }
    while (points[points.length-1].x > this.viewWidth()) {
      points.forEach(point => point.x -= this.viewWidth());
    }
    return points;
  }

  convertPoints(points) {
    // return points.flatMap(point => [point.x, point.y]);
    const newPoints = [];
    points.forEach(point => newPoints.push(point.x, point.y));
    return newPoints;
  }

  updateLines(points) {
    points = this.normalizePoints(this._points);

    // Arrow always has end point in view
    this.arrow.points(this.convertPoints(points));
    this.arrow.visible(true);

    // Hide unused lines
    this.lines.forEach(line => line.visible(false));

    let lineIndex = 0;
    const delta = (points[0].x < 0) ? this.viewWidth() : -this.viewWidth();
    while (points[0].x < 0 || points[0].x > this.viewWidth()) {
      points.forEach(point => point.x += delta);
      if (lineIndex >= this.lines.length) {
        this.addLine();
      }
      this.lines[lineIndex].points(this.convertPoints(points));
      this.lines[lineIndex].visible(true);
      lineIndex++;
    }
  }
}
